import { styled } from 'styled-components'
import theme from '../../Theme'
import { IconButton } from '@mui/material'
import Box from '@mui/material/Box'

export const StyledLayoutWrapper = styled(Box) <{ isMobile: boolean, inDrawer: boolean }>`
  height: 100%;
  width: ${(props) => props.isMobile || props.inDrawer ? '100%' : theme.spacing(64)};
  background: #F5F5F5;
  border-right: solid 1px #D7D8D9;
  display: ${(props) => props.isMobile || props.inDrawer ? 'flex' : ''};
  flex-direction: column;
`

export const StyledHeader = styled(Box)<{ showHamburger: boolean }>`
  height: ${theme.spacing(16)};
  font-weight: bold;
  font-size: ${theme.spacing(5)};
  border-bottom: solid 1px #D7D8D9;
  align-items: center;
  display: flex;
  justify-content: ${(props) => props.showHamburger ? 'space-between' : 'flex-start'};
  padding-left: ${theme.spacing(4)};
  padding-right: ${theme.spacing(2)};
  position: relative;
`

export const StyledList = styled(Box)`
  height: calc(100% - ${theme.spacing(34)});
  overflow-y: auto;
  min-width: ${theme.spacing(64)};
`

export const StyledListItem = styled(Box)`
  display: flex;
  align-items: center;
  padding: ${theme.spacing(2)} ${theme.spacing(4)};
  border-radius: ${theme.spacing(2)};
  margin: ${theme.spacing(0)} ${theme.spacing(4)};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  &.selectedSession {
    background: #E0E2E2;
  }
  &:hover {
    background: #CCCECF;
    /* reveal ellipsis button by setting opacity via child selector */
    & > .ellipsisButton {
      opacity: 1;
    }
  }
`

export const StyledEllipsisButton = styled.span`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${theme.spacing(0)};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 120ms ease-in-out;
  height: 1rem;
`

export const StyledDropdown = styled.div`
  position: absolute;
  flex-direction: column;
  transform: translateX(10rem) translateY(3rem);
  background: #fff;
  border: 1px solid #E0E2E2;
  border-radius: ${theme.spacing(2)};
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  z-index: 20;
  min-width: ${theme.spacing(24)};
  overflow: hidden;
`

export const StyledDropdownItem = styled.button`
  width: 100%;
  display: flex;
  padding: ${theme.spacing(2)} ${theme.spacing(3)};
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 0.95rem;
  &:hover {
    background: #f5f5f5;
  }
  & > svg {
    margin-right: 0.25rem;
    height: 1rem;
 }
  &.deleteMenuItem {
    color: red;
    & > svg {
      color: red;
    }
 }
`

export const StyledSearchInput = styled.input`
  width: 100%;
  margin: 0;
  padding: 0.5rem 0.5rem 0.5rem 1.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
  &:focus {
    border-color: #888;
    outline: none;
  }
`

export const StyledSearchContainer = styled.div`
  margin: 1rem;
  position: relative;
  width: calc(100% - 2rem);
`

export const StyledSearchIcon = styled.div`
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1rem;
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  pointer-events: none;
`

export const StyledInput = styled.input`
  flex-grow: 1;
  width: 100%;
  background: transparent;
  border: none;
  color: inherit;
  font: inherit;
  padding: 0;
  margin: 0;
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: #888;
    opacity: 1;
  }
`

export const StyledHeaderTitle = styled.div`
  font-weight: bold;
  font-size: ${theme.spacing(5)};
  color: black;  
  text-align: left;
  display: flex;
`

export const StyledIconButton = styled(IconButton)`
  height: 100%;
  align-items: center; 
  justify-content: center;
  color: #000 !important;  
  display: flex;
  padding: ${theme.spacing(0)} ${theme.spacing(3)} ${theme.spacing(0)} ${theme.spacing(0)} !important;
  &:hover {
    background-color: transparent !important;
  }
  &.closeButton {
    padding: ${theme.spacing(0)} ${theme.spacing(2)} !important;
  }
`

export const StyledSessionName = styled.div`
  text-align: left;
  flex-grow: 1;
`

export const StyledEmptyList = styled.div`
  padding: ${theme.spacing(4)};
  text-align: center;
  color: #888;
  font-size: 1rem;
`
